import classNames from "classnames";
import React, { ReactNode } from "react";

type TextKeys = 'H1' | 'H2' | 'H3' | 'H4' | 'H5' | 'H6' | 'Paragraph' | 'Bold' | 'Gray' | 'Small' | 'Large';

export const Text: { [key in TextKeys]: React.FC<{ children: ReactNode, className?: string }> } = {
  H1: ({ children, className }) => {
    return <h1 className={className}>{children}</h1>
  },
  H2: ({ children, className }) => {
    return <h2 className={className}>{children}</h2>
  },
  H3: ({ children, className }) => {
    return <h3 className={className}>{children}</h3>
  },
  H4: ({ children, className }) => {
    return <h4 className={className}>{children}</h4>
  },
  H5: ({ children, className }) => {
    return <h5 className={className}>{children}</h5>
  },
  H6: ({ children, className }) => {
    return <h6 className={className}>{children}</h6>
  },
  Paragraph: ({ children, className }) => {
    return <p className={classNames('paragraph', className)}>{children}</p>
  },
  Bold: ({ children, className }) => {
    return <p className={classNames('bold', className)}>{children}</p>
  },
  Gray: ({ children, className }) => {
    return <p className={classNames('text-gray', className)}>{children}</p>
  },
  Small: ({ children, className }) => {
    return <p className={classNames('text-small', className)}>{children}</p>
  },
  Large: ({ children, className }) => {
    return <p className={classNames('text-large', className)}>{children}</p>
  },
}